import React from 'react';
import { Select, SelectProps } from 'antd';
import { TpAuthorizationDetailResponse } from 'services/thirdParty';
import { noop } from 'lodash';

export type TpAuthorizationSelectProps = SelectProps<any> & {
  authDetailList: TpAuthorizationDetailResponse[];
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
  onSelected?: any;
};

const TpAuthorizationUseSelect = ({
  authDetailList,
  onSelected,
  onChange = noop,
  ...otherProps
}: TpAuthorizationSelectProps) => {
  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value, option);
    if (onSelected) {
      onSelected(authDetailList?.find((item) => item.authdetailid === value)!);
    }
  };
  

  return (
    <Select {...otherProps} onChange={handleChange}>
      {authDetailList?.map((tpauth) => (
        <Select.Option value={tpauth.authdetailid} key={tpauth.authdetailid}>
          {tpauth.prcodelabel +
            ' ' +
            tpauth.offerlabel +
            ' ' +
           ( tpauth.ofridlabel==null?'': tpauth.ofridlabel)}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TpAuthorizationUseSelect;
